module.exports = __webpack_public_path__ + "img/ballLoad.21cd246f.gif";